import { jsx as a } from "react/jsx-runtime";
import { c as m, a as t, d as i, B as l, e as p } from "./helpers-458d7e27.js";
import { M as s } from "./MinimalImageFrame-6a4f63a6.js";
import { A as u } from "./AppDownload-79ac7787.js";
import { T as c } from "./TextGroup-dd19925e.js";
const e = (o = {}) => /* @__PURE__ */ a(
  m,
  {
    ...o,
    modalWrapper: t
  }
);
e.displayName = i;
const d = "MinimalButtonGroup", r = (o = {}) => /* @__PURE__ */ a(
  l,
  {
    disclosureWrapper: p,
    inlinePlayButtonWrapper: e,
    ...o
  }
);
r.displayName = d;
const M = "MinimalAppDownloadGroup", n = (o = {}) => /* @__PURE__ */ a(
  u,
  {
    buttonGroupWrapper: r,
    disclosureWrapper: p,
    imageFrameWrapper: s,
    ...o
  }
);
n.displayName = M;
const G = "MinimalTextGroup", W = (o = {}) => /* @__PURE__ */ a(
  c,
  {
    appDownloadGroupWrapper: n,
    buttonGroupWrapper: r,
    disclosureWrapper: p,
    ...o
  }
);
W.displayName = G;
export {
  W as M
};
//# sourceMappingURL=MinimalTextGroup-0c5b3b52.js.map
